export default function ({ isOpen = false } = {}) {
    return {
        isOpen,
        title: '',
        content: '',
        scrollAtTop: false,
        cssClass: '',

        init() {
            this.setupListeners();
        },

        setupListeners() {
            window.addEventListener('modal-open', ({ detail }) => {
                const { template = '' } = detail;

                template
                    ? this.setContentFromTemplate(detail)
                    : this.setContent(detail);
            });

            window.addEventListener('modal-close', () => {
                this.resetModal();
            });
        },

        resetModal() {
            this.title = '';
            this.content = '';
            this.cssClass = '';
            this.isOpen = false;
        },

        setContentFromTemplate({ template = '', cssClass = '' }) {
            const templateElement = document.querySelector(template);

            if (!templateElement) return;

            this.cssClass = cssClass;
            this.content = templateElement.innerHTML;
            this.isOpen = true;
        },

        setContent({ content = '', title = '', cssClass = '' }) {
            this.title = title;
            this.content = content;
            this.cssClass = cssClass;

            if (title || content) {
                this.isOpen = true;
            }
        }
    };
}
